<div class="container-fluid">
    <app-page-title title="Fuel Surcharges"></app-page-title>
    <form [formGroup]="fuelSurchargesForm" (ngSubmit)="upsertFuelSurcharges()"(keydown.enter)="useEnterKey ? $event.preventDefault() : upsertFuelSurcharges()">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="mb-2">
                                <label class="form-label" for="chargetype">Charge Type<span
                                        class="mandatory">*</span></label>
                                <ng-select id="chargetype" [items]="chargeTypeOptions" formControlName="ddlChargeType"
                                    bindLabel="name" [bindValue]="'name'" placeholder="Select" aria-required="true"
                                    [appendTo]="'body'" [openOnEnter]="false" (change)="selectChargeType()"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || fuelSurchargesForm.get('ddlChargeType')?.touched) && fuelSurchargesForm.get('ddlChargeType').errors}" >
                                </ng-select>
                                <div *ngIf="(isFormSubmitted || fuelSurchargesForm.get('ddlChargeType')?.touched) && fuelSurchargesForm.get('ddlChargeType').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="fuelSurchargesForm.get('ddlChargeType').errors.required">Charge Type is
                                        required</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="mb-2">
                                <label class="form-label" for="fromDate">From Date<span
                                        class="mandatory">*</span></label>
                                <input class="form-control form-control-sm" type="date" formControlName="txtFromDate"
                                    id="fromDate" [min]="currentDate"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || fuelSurchargesForm.get('txtFromDate')?.touched) && fuelSurchargesForm.get('txtFromDate').errors}" >
                                <div *ngIf="(isFormSubmitted || fuelSurchargesForm.get('txtFromDate')?.touched) && fuelSurchargesForm.get('txtFromDate').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="fuelSurchargesForm.get('txtFromDate').errors.required">From Date is
                                        required</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="mb-2">
                                <label class="form-label" for="toDate">To Date<span class="mandatory">*</span></label>
                                <input class="form-control form-control-sm" type="date" formControlName="txtToDate"
                                    id="toDate" [min]="currentDate"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || fuelSurchargesForm.get('txtToDate')?.touched) && fuelSurchargesForm.get('txtToDate').errors}" >
                                <div *ngIf="(isFormSubmitted || fuelSurchargesForm.get('txtToDate')?.touched) && fuelSurchargesForm.get('txtToDate').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="fuelSurchargesForm.get('txtToDate').errors.required">To Date is
                                        required</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="mb-2">
                                <label class="form-label" for="percentage">Percentage<span
                                        class="mandatory">*</span></label>
                                <input class="form-control form-control-sm" type="number"
                                    formControlName="txtPercentage" id="percentage"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || fuelSurchargesForm.get('txtPercentage')?.touched) && fuelSurchargesForm.get('txtPercentage').errors}" >
                                <div *ngIf="(isFormSubmitted || fuelSurchargesForm.get('txtPercentage')?.touched) && fuelSurchargesForm.get('txtPercentage').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="fuelSurchargesForm.get('txtPercentage').errors.required">Percentage
                                        is required</span>
                                    <span *ngIf="fuelSurchargesForm.get('txtPercentage').errors.pattern"> Please enter a
                                        valid percentage (1.00 to 100.00).</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">
                            <div class="mb-2">
                                <label class="form-label" for="customer">Customer<span
                                        *ngIf="fuelSurchargesForm.get('ddlChargeType').value==='Customer'"
                                        class="mandatory">*</span></label>
                                <ng-select id="customer" [items]="customerOptions" formControlName="txtCustomer"
                                    bindLabel="name" [bindValue]="'id'" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                    (change)="onValueChange('Customer')"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || fuelSurchargesForm.get('txtCustomer')?.touched) && fuelSurchargesForm.get('txtCustomer').errors}" >
                                </ng-select>
                                <div *ngIf="(isFormSubmitted || fuelSurchargesForm.get('txtCustomer')?.touched) && fuelSurchargesForm.get('txtCustomer').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="fuelSurchargesForm.get('txtCustomer').errors.required">Customer is
                                        Required</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="mb-2">
                                <label class="form-label" for="vendor">Vendor<span
                                        *ngIf="fuelSurchargesForm.get('ddlChargeType').value==='Vendor'"
                                        class="mandatory">*</span></label>
                                <ng-select id="vendor" [items]="vendorOptions" formControlName="txtVendor"
                                    bindLabel="name" [bindValue]="'id'" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                    (change)="onValueChange('Vendor');bindService()"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || fuelSurchargesForm.get('txtVendor')?.touched) && fuelSurchargesForm.get('txtVendor').errors}" >
                                </ng-select>
                                <div *ngIf="(isFormSubmitted || fuelSurchargesForm.get('txtVendor')?.touched) && fuelSurchargesForm.get('txtVendor').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="fuelSurchargesForm.get('txtVendor').errors.required">Vendor is
                                        Required</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="mb-2">
                                <label class="form-label" for="service">Service</label>
                                <ng-select id="service" [items]="serviceOptions" formControlName="txtService"
                                    bindLabel="servicename" [bindValue]="'id'" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" >
                                </ng-select>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="mb-2">
                                <label class="form-label" for="vendor">Product</label>
                                <ng-select id="product" [items]="productOptions" formControlName="txtProduct"
                                    bindLabel="name" [bindValue]="'id'" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" >
                                </ng-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="col-md-6">
            <div class="card">
                <div class="card-header bg-transparent border-bottom text-uppercase"> DESTINATION </div>
                <div class="card-body">
                    <div class="row" formGroupName="destination">
                        <div class="col-md-4">
                            <div class="mb-2">
                                <label for="country" class="form-label">Country</label>
                                <ng-select id="country" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" [clearable]="false"
                                    [items]="destinationcountryList" bindLabel="name" [bindValue]="'isocode'"
                                    formControlName="ddlCountry" (change)="onDestinationCountryChange()" >
                                </ng-select>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="mb-2">
                                <label for="state" class="form-label">State</label>
                                <ng-select id="state" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" [clearable]="false"
                                    (change)="onDestinationStateChange()" [items]="destinationstateList"
                                    bindLabel="name" [bindValue]="'isocode'" formControlName="ddlState" >
                                </ng-select>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="mb-2">
                                <label for="city" class="form-label">City</label>
                                <ng-select id="city" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" [clearable]="false"
                                    [items]="destinationcityList" bindLabel="name" [bindValue]="'isocode'"
                                    formControlName="ddlCity" >
                                </ng-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-2 mb-2">
            <div class="col-md-2">
                <div class="mb-2">
                    <button type="submit" class="btn btn-primary" >{{isFuelSurchargesEdit? 'Update': 'Create'}}</button>
                    <button *ngIf="isFuelSurchargesEdit" type="button" class="btn btn-secondary" (click)="resetForm();onValueChange(chargeType)">Cancel</button>
                </div>
            </div>
        </div>
    </form>

    <!-- <div class="card">
        <div class="card-header bg-transparent border-bottom text-uppercase">FuelSurcharges</div>
        <div class="card-body">
            
        </div>
    </div> -->
    <div class="row">
        <div class="col-md-12 ">
            <ag-grid-angular #agGrid id="myGrid" class="ag-theme-balham" [rowData]="rowData"
                [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
                [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" [suppressMenuHide]="true"
                [pagination]="true" (gridReady)="onGridReady($event)">
            </ag-grid-angular>
        </div>
    </div>
</div>